import { LucideProps } from "lucide-react";
import React from "react";

export const Icons = {
  charger: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 11v8H6V5h6v6zm6-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-8-4l-4 7.5h2V18l4-7h-2z" />
    </svg>
  ),
  chargerSlim: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="2 2 20 20"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 11v8H6V5h6v6zm6-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-8-4l-4 7.5h2V18l4-7h-2z" />
    </svg>
  ),
  ccs: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      fill="currentColor"
      viewBox="6 2.5 12 19.5"
      {...props}
    >
      <path d="M9.69,6a.75.75,0,1,1,.75.75A.76.76,0,0,1,9.69,6Zm3.83.75A.75.75,0,1,0,12.77,6,.76.76,0,0,0,13.52,6.75ZM12,9.71a1,1,0,1,0-1-1A1,1,0,0,0,12,9.71Zm-3.15,0a1,1,0,1,0-1-1A1,1,0,0,0,8.85,9.71Zm6.3,0a1,1,0,1,0-1-1A1,1,0,0,0,15.15,9.71Zm-4.73.77a1,1,0,1,0,1,1A1,1,0,0,0,10.42,10.48Zm3.16,0a1,1,0,1,0,1,1A1,1,0,0,0,13.58,10.48ZM11,18a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,11,18Zm-1,0a.5.5,0,1,0-.5.5A.5.5,0,0,0,10,18Zm6,0a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,16,18Zm-1,0a.5.5,0,1,0-.5.5A.5.5,0,0,0,15,18Zm4,0a4,4,0,0,1-4,4H9a4,4,0,0,1-1.12-7.84A7,7,0,0,1,6.25,4.5,7.22,7.22,0,0,1,7.67,3h8.66a7.22,7.22,0,0,1,1.42,1.5,7,7,0,0,1-1.63,9.66A4,4,0,0,1,19,18Zm-7-4a5.5,5.5,0,0,0,5.5-5.5,5.4,5.4,0,0,0-1-3.14,5,5,0,0,0-.74-.86H8.23a5.57,5.57,0,0,0-.75.86A5.5,5.5,0,0,0,12,14Zm5.5,4A2.5,2.5,0,0,0,15,15.5H9a2.5,2.5,0,0,0,0,5h6A2.5,2.5,0,0,0,17.5,18Z" />
    </svg>
  ),
  chademo: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="1.5 1.5 21 21"
      fill="currentColor"
      {...props}
    >
      <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm3.5-10a2,2,0,1,0,2,2A2,2,0,0,0,15.5,10Zm0,3a1,1,0,1,1,1-1A1,1,0,0,1,15.5,13Zm-7-3a2,2,0,1,0,2,2A2,2,0,0,0,8.5,10Zm0,3a1,1,0,1,1,1-1A1,1,0,0,1,8.5,13Zm1.75-4.17,1.06-1.06L10.25,6.71,11,6,12,7.06,13.08,6l.71.71L12.72,7.77l1.07,1.06-.71.71L12,8.47,11,9.54Zm3.54,6.34-1.07,1.06,1.07,1.06-.71.71L12,16.93,11,18l-.71-.71,1.06-1.06-1.06-1.06.71-.71L12,15.52l1.06-1.06Z" />
    </svg>
  ),
  schuko: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="1.5 1.5 21 21"
      fill="currentColor"
      {...props}
    >
      <path d="M9.5 12C9.5 12.6904 8.94036 13.25 8.25 13.25C7.55964 13.25 7 12.6904 7 12C7 11.3096 7.55964 10.75 8.25 10.75C8.94036 10.75 9.5 11.3096 9.5 12Z" />
      <path d="M17 12C17 12.6904 16.4404 13.25 15.75 13.25C15.0596 13.25 14.5 12.6904 14.5 12C14.5 11.3096 15.0596 10.75 15.75 10.75C16.4404 10.75 17 11.3096 17 12Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11 19.9381V18H13V19.9381C16.9463 19.446 20 16.0796 20 12C20 7.92038 16.9463 4.55399 13 4.06189V6H11V4.06189C7.05369 4.55399 4 7.92038 4 12C4 16.0796 7.05369 19.446 11 19.9381Z"
      />
    </svg>
  ),
  type2: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="1.5 2 21 20"
      fill="currentColor"
      {...props}
    >
      <path d="M10.75 7.25C10.75 7.94036 10.1904 8.5 9.5 8.5C8.80964 8.5 8.25 7.94036 8.25 7.25C8.25 6.55964 8.80964 6 9.5 6C10.1904 6 10.75 6.55964 10.75 7.25Z" />
      <path d="M15.75 7.25C15.75 7.94036 15.1904 8.5 14.5 8.5C13.8096 8.5 13.25 7.94036 13.25 7.25C13.25 6.55964 13.8096 6 14.5 6C15.1904 6 15.75 6.55964 15.75 7.25Z" />
      <path d="M13.5 11.5C13.5 12.3284 12.8284 13 12 13C11.1716 13 10.5 12.3284 10.5 11.5C10.5 10.6716 11.1716 10 12 10C12.8284 10 13.5 10.6716 13.5 11.5Z" />
      <path d="M8.5 11.5C8.5 12.3284 7.82843 13 7 13C6.17157 13 5.5 12.3284 5.5 11.5C5.5 10.6716 6.17157 10 7 10C7.82843 10 8.5 10.6716 8.5 11.5Z" />
      <path d="M18.5 11.5C18.5 12.3284 17.8284 13 17 13C16.1716 13 15.5 12.3284 15.5 11.5C15.5 10.6716 16.1716 10 17 10C17.8284 10 18.5 10.6716 18.5 11.5Z" />
      <path d="M11 16C11 16.8284 10.3284 17.5 9.5 17.5C8.67157 17.5 8 16.8284 8 16C8 15.1716 8.67157 14.5 9.5 14.5C10.3284 14.5 11 15.1716 11 16Z" />
      <path d="M16 16C16 16.8284 15.3284 17.5 14.5 17.5C13.6716 17.5 13 16.8284 13 16C13 15.1716 13.6716 14.5 14.5 14.5C15.3284 14.5 16 15.1716 16 16Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 19.5C16.3032 19.5 20 15.7504 20 10.86C20 8.99332 19.4536 7.27778 18.535 5.87651C18.2057 5.37431 17.8291 4.91309 17.4132 4.5H6.58675C6.1709 4.91309 5.79426 5.37431 5.46503 5.87651C4.54641 7.27778 4 8.99332 4 10.86C4 15.7504 7.69679 19.5 12 19.5ZM5.81343 2.5H18.1866C18.9608 3.14952 19.6426 3.91818 20.2076 4.78C21.3374 6.50343 22 8.59938 22 10.86C22 16.7363 17.5228 21.5 12 21.5C6.47715 21.5 2 16.7363 2 10.86C2 8.59938 2.66259 6.50343 3.79241 4.78C4.35739 3.91818 5.03921 3.14952 5.81343 2.5Z"
      />
    </svg>
  ),
  unknown: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="80 -880 800 800"
      fill="currentColor"
      {...props}
    >
      <path d="M478-240q21 0 35.5-14.5T528-290q0-21-14.5-35.5T478-340q-21 0-35.5 14.5T428-290q0 21 14.5 35.5T478-240Zm-36-154h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
    </svg>
  ),
  chargingTag: ({ ...props }: LucideProps) => (
    <svg
      width="28.765486"
      height="25.242792"
      viewBox="0 0 28.765486 25.242792"
      fill="none"
      version="1.1"
      id="svg8"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs id="defs12" />
      <path
        d="m 15.574437,12.400718 c -0.3951,-0.5815 -1.1548,-0.7266 -1.7364,-0.3314 -0.5654,0.3841 -0.7266,1.1548 -0.331399,1.7364 0.3841,0.5654 1.1709,0.7156 1.7364,0.3315 0.5816,-0.3952 0.7266,-1.1549 0.331399,-1.7365 z m 2.5959,-1.74 c -0.7793,-1.1470002 -1.9186,-1.9550002 -3.259699,-2.2954002 -0.336501,-0.0783 -0.6706,0.1251 -0.776,0.4565 -0.0783,0.3365 0.125,0.6706 0.4616,0.7489 1.0316,0.2672 1.936399,0.9039002 2.540099,1.7925002 0.5927,0.8724 0.851401,1.9481 0.7198,3.0056 -0.0311,0.1628 0.0134,0.2979 0.1013,0.4271 0.0987,0.1454 0.235,0.2417 0.4249,0.278 0.3579,0.0402 0.6591,-0.2117 0.7103,-0.5534 0.1614,-1.3611 -0.154,-2.7289 -0.9223,-3.8598 z m 3.968,4.624 c 0.3704,-2.2351 -0.11,-4.5062 -1.3832,-6.3802002 -1.284199,-1.8901 -3.218599,-3.1733 -5.432999,-3.6523 -0.325601,-0.0621 -0.6758,0.1522 -0.7379,0.4778 -0.0674,0.3527 0.136,0.6868 0.4887,0.7541 1.893999,0.3897 3.550699,1.5074 4.648299,3.1229 1.086601,1.5994002 1.5045,3.5351002 1.18,5.4556002 -0.0201,0.1789 0.0193,0.3411 0.1071,0.4704 0.0878,0.1292 0.2241,0.2255 0.414,0.2618 0.325601,0.0621 0.653901,-0.1845 0.716,-0.5101 z"
        fill="currentColor"
        id="path2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m 5.0721375,16.302818 c -0.75,0.0884 -1.47682,0.4204 -2.05228,0.9958 -1.35981,1.3598 -1.35981,3.5645 0,4.9243 1.35978,1.3598 3.56448,1.3598 4.92428,0 1.3013,-1.3013 1.3573,-3.3763 0.1679,-4.7442 0.198,-0.8286 0.7713,-1.2884 1.6639,-1.1267 1.7128005,2.1521 1.5736005,5.2939 -0.4176,7.2851 -2.1408,2.1409 -5.6118,2.1409 -7.7527,0 -2.14085,-2.1408 -2.14085,-5.6118 0,-7.7527 0.91236,-0.9123 2.0663,-1.4359 3.2559,-1.5706 0.0106,0.6195 0.0644,1.325 0.2106,1.989 z"
        fill="currentColor"
        id="path4"
      />
      <path
        d="m 12.608438,2.9967178 c 4.172199,-3.09603002 10.064299,-2.22359002 13.1603,1.9486 3.0961,4.1723 2.2236,10.0644002 -1.9486,13.1604002 -2.1431,1.5903 -5.8499,2.9668 -9.4559,3.3622 -1.7914,0.1964 -3.4917,0.1427 -4.9131005,-0.2085 -1.4206,-0.351 -2.4864,-0.9776 -3.1481,-1.8694 -0.6618,-0.8918 -0.9527,-2.0934 -0.8769,-3.5547 0.0758,-1.4623 0.517,-3.1051 1.2241,-4.7627 1.4234,-3.3367002 3.8151005,-6.4856002 5.9582005,-8.0759002 z"
        stroke="currentColor"
        strokeWidth="2.3"
        id="path6"
      />
    </svg>
  ),
  phone: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M280-40q-33 0-56.5-23.5T200-120v-720q0-33 23.5-56.5T280-920h400q33 0 56.5 23.5T760-840v720q0 33-23.5 56.5T680-40H280Zm0-200v120h400v-120H280Zm200 100q17 0 28.5-11.5T520-180q0-17-11.5-28.5T480-220q-17 0-28.5 11.5T440-180q0 17 11.5 28.5T480-140ZM280-320h400v-400H280v400Zm0-480h400v-40H280v40Zm0 560v120-120Zm0-560v-40 40Z" />
    </svg>
  ),
  ocpi: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M220-80q-58 0-99-41t-41-99q0-58 41-99t99-41q18 0 35 4.5t32 12.5l153-153v-110q-44-13-72-49.5T340-740q0-58 41-99t99-41q58 0 99 41t41 99q0 48-28 84.5T520-606v110l154 153q15-8 31.5-12.5T740-360q58 0 99 41t41 99q0 58-41 99t-99 41q-58 0-99-41t-41-99q0-18 4.5-35t12.5-32L480-424 343-287q8 15 12.5 32t4.5 35q0 58-41 99t-99 41Zm520-80q25 0 42.5-17.5T800-220q0-25-17.5-42.5T740-280q-25 0-42.5 17.5T680-220q0 25 17.5 42.5T740-160ZM480-680q25 0 42.5-17.5T540-740q0-25-17.5-42.5T480-800q-25 0-42.5 17.5T420-740q0 25 17.5 42.5T480-680ZM220-160q25 0 42.5-17.5T280-220q0-25-17.5-42.5T220-280q-25 0-42.5 17.5T160-220q0 25 17.5 42.5T220-160Z" />
    </svg>
  ),
  unknownStarter: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M480-280q-17 0-29.5-12.5T438-322q0-17 12.5-29.5T480-364q17 0 29.5 12.5T522-322q0 17-12.5 29.5T480-280Zm-30-128q0-46 7.5-63t42.5-47q14-14 24-27.5t10-30.5q0-18-13.5-32T480-622q-27 0-41 15.5T420-574l-54-22q12-35 41-59.5t73-24.5q47 0 80.5 25.5T594-578q0 24-12 45t-30 39q-30 30-36 42t-6 44h-60ZM280-40q-33 0-56.5-23.5T200-120v-720q0-33 23.5-56.5T280-920h400q33 0 56.5 23.5T760-840v720q0 33-23.5 56.5T680-40H280Zm0-120v40h400v-40H280Zm0-80h400v-480H280v480Zm0-560h400v-40H280v40Zm0 0v-40 40Zm0 640v40-40Z" />
    </svg>
  ),
  products: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="m260-520 220-360 220 360H260ZM700-80q-75 0-127.5-52.5T520-260q0-75 52.5-127.5T700-440q75 0 127.5 52.5T880-260q0 75-52.5 127.5T700-80Zm-580-20v-320h320v320H120Zm580-60q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29Zm-500-20h160v-160H200v160Zm202-420h156l-78-126-78 126Zm78 0ZM360-340Zm340 80Z" />
    </svg>
  ),
};
